var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g({attrs:{"color":"primary","small":"","text":"","disabled":""},on:{"click":_vm.refresh}},on),[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-refresh")])],1)]}}])},[_c('span',[_vm._v("Refresh")])])
}
var staticRenderFns = []

export { render, staticRenderFns }